import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';
import { useSetup } from '../context/SetupContext';
import '../styles/Layout.css';

export default function Layout() {
  const { isAuthenticated, isSuperAdmin } = useAuth();
  const { hasTypes, checking } = useSetup();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={`/login${location.search}`} replace />;
  }

  const onTypesPage = location.pathname === '/reservation-types';
  // Contact Us must stay reachable while the salon is still finishing setup.
  const onContactPage = location.pathname === '/contact';
  const needsSetup = !isSuperAdmin && hasTypes === false;

  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">
        {!isSuperAdmin && checking ? (
          <div className="page-loading">جاري التحميل...</div>
        ) : needsSetup && !onTypesPage && !onContactPage ? (
          <Navigate to="/reservation-types" replace />
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
